import { UiFooterNavModel } from "../../models";

export function mockUiFooterNavModel({
    id = "footer-nav-1234",
    type = "uiFooterNav",
    locale = "en",
    content = mockUiFooterNavModelContent()
}: Partial<UiFooterNavModel> = {}): UiFooterNavModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiFooterNavModelContent = UiFooterNavModel["content"];

export function mockUiFooterNavModelContent({
    entryTitle = "test-new-footer",
    ...optionals
}: Partial<UiFooterNavModelContent> = {}): UiFooterNavModelContent {
    return {
        entryTitle,
        ...optionals
    };
}
